module.exports = __webpack_public_path__ + "static/img/2.3250f4f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/eng/2.png
// module id = YOlF
// module chunks = 0